import { questionCollection, getAiRewriteQuery } from "@/api/home";
const home = {
  namespaced: true,
  state: {
    questionFetching: false,
    questionMap: {
      // [modelId]: [questionList]
    },
    defaultQuestions: [],
    basisFetching: false,
    referenceBasisList: [],
  },
  mutations: {
    setQuestionFetching(state, fetching) {
      state.questionFetching = fetching;
    },
    setBasisFetching(state, fetching) {
      state.basisFetching = fetching;
    },
    setQuestionMap(state, { modelId, questions }) {
      state.questionMap = {
        ...state.questionMap,
        [modelId]: questions,
      };
    },
    setDefaultQuestions(state, questions) {
      state.defaultQuestions = questions;
    },
    setReferenceBasisList(state, list) {
      state.referenceBasisList = list;
    },
  },
  actions: {
    async getQuestionList({ commit, state, rootState }, payload) {
      try {
        const params = {
          catalogId: "562813729914949",
          userId: rootState.user.userInfo.userId,
          pageNumber: 1,
          pageSize: 100,
          tagName: {
            567158312001605: [payload.name || ""],
          },
          orderByStr: "",
          search: payload.keywords || "",
          attributes: [""],
          checkFlag: "all",
        };
        if (payload.modelId && state.questionMap[payload.modelId]) {
          console.log("Using cached questions for modelId:", payload.modelId);
          return;
        }
        if (!payload.modelId && state.defaultQuestions.length) {
          console.log("Using cached default questions");
          return;
        }
        commit("setQuestionFetching", true);
        const res = await questionCollection(params);

        if (!payload.modelId) {
          commit(
            "setDefaultQuestions",
            res.list.map((item) => ({
              id: item.contentId,
              catalogId: item.catalogId,
              title: item.title,
              summary: item.summary,
              contentType: item.contentType,
            }))
          );
          return;
        }
        commit("setQuestionMap", {
          modelId: payload.modelId,
          questions: res.list.map((item) => ({
            id: item.contentId,
            catalogId: item.catalogId,
            title: item.title,
            summary: item.summary,
            contentType: item.contentType,
          })),
        });
      } catch (error) {
      } finally {
        commit("setQuestionFetching", false);
      }
    },
    async getReferenceBasisList({ commit, rootState }) {
      try {
        const params = {
          conversationId: rootState.chat.currentChatId,
          userId: rootState.user.userInfo.userId,
        };
        commit("setBasisFetching", true);
        const res = await getAiRewriteQuery(params);
        const list = res.map((item) => {
          // 使用正则提取三部分
          const docMatch = item.content.match(/【文档名】[:：]?([^【]*)/);
          const titleMatch = item.content.match(/【标题】[:：]?([^【]*)/);
          const bodyMatch = item.content.match(/【正文】[:：]?([\s\S]*)/);

          const doc = docMatch && docMatch[1] ? docMatch[1].trim() : "";
          const title = titleMatch && titleMatch[1] ? titleMatch[1].trim() : "";
          const body = bodyMatch && bodyMatch[1] ? bodyMatch[1].trim() : "";

          return {
            documentName: doc,
            title: title,
            desc: body.substring(0, 80),
            content: body,
          };
        });
        commit("setReferenceBasisList", list);
      } catch (error) {
        console.error("Error fetching reference basis:", error);
      } finally {
        commit("setBasisFetching", false);
      }
    },
  },
  getters: {},
};

export default home;
